import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const useNavigateApi = () => {
  const navigate = useNavigate();
  const lang = useSelector((state) => state.lang);

  return useMemo(
    () => (path, options) => {
      const { newTab, ...navigateOptions } = options || {};

      if (path === -1 || path === '-1') {
        navigate(path, navigateOptions);
      } else {
        const pathWithLang = `/${lang}${
          path.startsWith('/') ? '' : '/'
        }${path}`;

        if (newTab) {
          window.open(
            `${window.location.origin}${pathWithLang}`,
            '_blank',
            'noopener,noreferrer'
          );
          return;
        }

        navigate(pathWithLang, navigateOptions);
      }
    },
    [lang, navigate]
  );
};

export default useNavigateApi;
